/**
 * Defaults the popup downwards and aligns left side with the toggler
 * @param { DOMRect } toggler the "button" that opens the popup
 * @param { DOMRect } popup the popup container
 * @param { number } padding the space around the popup for box-shadow
 * @param { boolean } right positions the popup to align with the right side of the toggler
 * @param { boolean } center positions the popup to center the toggler
 * @param { boolean } up change the default position of the toggler upwards
 * @returns Popup css position to be added as css variable: top right bottom left
 */
export const popupPosition = (
  toggler: DOMRect,
  popup: DOMRect,
  padding: number,
  right: boolean,
  center: boolean,
  up: boolean,
) => {
  const left = leftPosition(toggler, popup, padding, right, center);
  const direction = popupDirection(toggler, popup, up);

  return `${direction.top} auto ${direction.bottom} ${left}`;
};

/**
 * @param { DOMRect } toggler the "button" that opens the popup
 * @param { DOMRect } popup the popup container
 * @param { boolean } up change the default position of the toggler upwards
 * @returns Popup css position bottom and top
 *          bottom auto -> the dropdown go downwards
 *          top auto    -> the dropdown go upwards
 */
const popupDirection = (toggler: DOMRect, popup: DOMRect, up: boolean) => {
  const popupHeight = popup.height;
  const spaceOverToggler = toggler.top;
  const spaceUnderToggler = window.innerHeight - toggler.bottom;

  if (
    (up &&
      (popupHeight <= spaceOverToggler ||
        spaceOverToggler >= spaceUnderToggler)) ||
    (popupHeight > spaceUnderToggler && spaceOverToggler > spaceUnderToggler)
  ) {
    return { bottom: `${window.innerHeight - toggler.top}px`, top: 'auto' };
  }

  return { bottom: 'auto', top: `${toggler.top + toggler.height}px` };
};

/**
 * Calculates and set the height of the dropdown container
 * @param { DOMRect } toggler the "button" that opens the popup
 * @param { DOMRect } popup the popup container
 * @param { boolean } up change the default position of the toggler upwards
 * @returns the height of the dropdown, default auto
 */
export const calculatePopupHeight = (
  toggler: DOMRect,
  popup: DOMRect,
  up: boolean,
) => {
  const directionDown = popupDirection(toggler, popup, up).bottom === 'auto';
  const spaceUnderToggler = Math.round(window.innerHeight - toggler.bottom);
  const spaceOverToggler = Math.round(toggler.top);

  if (directionDown && spaceUnderToggler <= popup.height) {
    return `${spaceUnderToggler}px`;
  } else if (!directionDown && spaceOverToggler <= popup.height) {
    return `${spaceOverToggler}px`;
  }

  return 'auto';
};

/**
 *
 * @param { DOMRect } toggler the "button" that opens the popup
 * @param { DOMRect } popup the popup container
 * @param { number } padding the space around the popup for box-shadow
 * @param { boolean } right positions the popup to align with the right side of the toggler
 * @param { boolean } center positions the popup to center the toggler
 * @returns left in position of the toggler, sets to 0 if position is outside of the window
 */
const leftPosition = (
  toggler: DOMRect,
  popup: DOMRect,
  padding: number,
  right: boolean,
  center: boolean,
) => {
  let left = toggler.left - padding;

  if (right) {
    left = toggler.right + padding - popup.width;
  } else if (center) {
    left = toggler.left + toggler.width / 2 - popup.width / 2;
  }

  if (left < 0) {
    left = -padding;
  }

  return `${left}px`;
};
